import { render, staticRenderFns } from "./GreenTransportForm.vue?vue&type=template&id=2b2bfd09&scoped=true&"
import script from "./GreenTransportForm.vue?vue&type=script&lang=js&"
export * from "./GreenTransportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2bfd09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b2bfd09')) {
      api.createRecord('2b2bfd09', component.options)
    } else {
      api.reload('2b2bfd09', component.options)
    }
    module.hot.accept("./GreenTransportForm.vue?vue&type=template&id=2b2bfd09&scoped=true&", function () {
      api.rerender('2b2bfd09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/GreenTransportForm.vue"
export default component.exports